import { zergApi } from "@/service/zerg";

class TravelRoutesService {
    // async getDepartmentsProvisional(){
    //     try {
    //         const data = await zergApi.get("commons/departments");
    //         return data;
    //     } catch (error) {
    //         console.log(error);
    //     }
    // }

    async getDepartments() {
        try {
            const data = await zergApi.get("commons/get-departments");
            return data;
        } catch (error) {
            console.log(error)
        }
    }

    async getProvinces(id) {
        try {
            const data = await zergApi.get(`commons/get-provinces/${id}`);
            return data;
        } catch (error) {
            console.log(error)
        }
    }

    async getDistricts(id) {
        try {
            const data = await zergApi.get(`commons/get-districts/${id}`);
            return data;
        } catch (error) {
            console.log(error)
        }
    }

    async save(params) {
        try {
            const data = await zergApi.post("setting/travel-routes/save-zone", params);
            return data;
        } catch (error) {
            console.log(error)
        }
    }

    async verifyDuplicated(params) {
        try {
            const data = await zergApi.post("setting/travel-routes/verify-duplicated", params)
            return data
        } catch (error) {
            console.log(error)
        }
    }

    async verifyDuplicatedCode(params) {
        try {
            const data = await zergApi.post("setting/travel-routes/verify-duplicated-code", params)
            return data
        } catch (error) {
            console.log(error)
        }
    }

    async getZones(params) {
        try {
            const data = await zergApi.post("setting/travel-routes/get-zones", params);
            return data
        } catch (error) {
            throw error;
        }
    }

    async getZoneData(params) {
        try {
            const { data } = await zergApi.post("setting/travel-routes/get-zone-data", params)
            return data[0]
        } catch (error) {
            console.log(error)
        }
    }

    async getTravelRoutes(params) {
        try {
            const data = await zergApi.post("setting/travel-routes/get-travel-routes", params)
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getLocations(params) {
        try {
            const data = await zergApi.post("setting/travel-routes/get-locations", params)
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getLocationsForSelect(params) {
        try {
            const data = await zergApi.post("setting/travel-routes/get-locations-for-select", params)
            return data;
        } catch (error) {
            throw error;
        }
    }

    async updateCodes(params) {
        try {
            const data = await zergApi.post("setting/travel-routes/update-codes", params)
            return data;
        } catch (error) {
            throw error;
        }
    }

    async registerRoute(params) {
        try {
            const data = await zergApi.post("setting/travel-routes/register-route", params)
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getDataRouteById(params) {
        try {
            const data = await zergApi.post("setting/travel-routes/get-data-route-by-id", params)
            return data;
        } catch (error) {
            throw error;
        }
    }

    async updateRoute(params) {
        try {
            const data = await zergApi.post("setting/travel-routes/update-route", params)
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getRates(params) {
        try {
            const data = await zergApi.post("setting/travel-routes/get-rates", params)
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getTravelRoutesForSelect(params) {
        try {
            const data = await zergApi.post("setting/travel-routes/get-travel-routes-for-select", params)
            return data;
        } catch (error) {
            throw error;
        }
    }

    async registerRate(params) {
        try {
            const data = await zergApi.post("setting/travel-routes/register-rate", params)
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getDataRateById(params) {
        try {
            const data = await zergApi.post("setting/travel-routes/get-data-rate-by-id", params)
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getRegisteredQantitiesOfCards(){
        try {
            const data = await zergApi.post("setting/travel-routes/get-registered-quantities-of-cards")
            return data;
        } catch (error) {
            throw error;
        }
    }

    async updateRate(params){
        try {
            const data = await zergApi.post("setting/travel-routes/update-rate", params)
            return data
        } catch (error) {
            throw error;
        }
    }

    async getVehicleSettingsByClientAndServiceType(params){
        try {
            const data = await zergApi.post("setting/travel-routes/get-vehicle-settings-by-client-and-service-type", params)
            return data
        } catch (error) {
            throw error;
        }
    }

    async getMeasureTypesByClientAndServiceType(params){
        try {
            const data = await zergApi.post("setting/travel-routes/get-measure-types-by-client-and-service-type", params)
            return data
        } catch (error) {
            throw error;
        }
    }

    async getRatesByClientServiceTypeSettingVehicleAndMeasureType(params){
        try {
            const data = await zergApi.post("setting/travel-routes/get-rates-by-client-service-type-setting-vehicle-and-measure-type", params)
            return data
        } catch (error) {
            throw error;
        }
    }

    async getTollsForRoute(params){
        try {
            const data = await zergApi.post("setting/travel-routes/get-tolls-for-route", params)
            return data
        } catch (error) {
            throw error;
        }
    }

    async getTolls(){
        try {
            const data = await zergApi.get("setting/travel-routes/get-tolls")
            return data
        } catch (error) {
            throw error;
        }
    }

    async saveTollGroup(params){
        try {
            const data = await zergApi.post("setting/travel-routes/save-toll-group", params)
            return data
        } catch (error) {
            throw error;
        }
    }

    async validateUniqueName(params){
        try {
            const data = await zergApi.post("setting/travel-routes/validate-unique-name", params)
            return data
        } catch (error) {
            throw error;
        }
    }
}

export default new TravelRoutesService();